/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import { Box, IconButton, Popover, Stack, Typography } from '@mui/material';
import { MdCallEnd, MdCall } from 'react-icons/md';
import { IoMdMicOff, IoMdMic } from 'react-icons/io';
import { CallContext, LanguageContext } from '../../../../../../../../libs/Context';
import { setAudioCall } from '../../../../../../../../redux/CallsRedux';
import { setEachCallDetailChanges } from '../../../../../../../../redux/PresenceRedux';
import { useDispatch, useSelector } from 'react-redux';
import { PRESENCE_ENUMS } from '../../../../../../../../libs/enums/presenceEnums';

const AudioCallsFooter = ({ onGoingCall, handleEndCall }) =>
{
	const [ anchorEl, setAnchorEl ] = useState(null);
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;
	const { language } = useContext(LanguageContext);
	const menuValues = [ language?.screen_share, language?.openChat, language?.addUsers,
		language?.settings ];
	const dispatch = useDispatch();
	const callDetails = useSelector((state:any) => state?.mypresence?.callDetails);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { updateCallDetails, peerConnectionClose, handleAccept, handleAudioOff, setUpGroupCallInfo } = useContext(CallContext);
	const callData = useSelector((state:any) => state?.call);

	const handleMenu = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () =>
	{
		setAnchorEl(null);
	};

	const handleCallCancel = async () =>
	{
		if (callDetails?.type === PRESENCE_ENUMS.individual)
		{
			updateCallDetails(callDetails?.initiator === userData?.userId ? PRESENCE_ENUMS.missed : PRESENCE_ENUMS.declined, null, callDetails);
		}
		else if (callDetails?.type === PRESENCE_ENUMS.group)
		{
			dispatch(setEachCallDetailChanges({ status: PRESENCE_ENUMS.declined, groupId: callDetails?.groupId, callId: callDetails?.callId }));
			setUpGroupCallInfo('declined', callDetails);
		}
		dispatch(setAudioCall(''));
		peerConnectionClose(callDetails?.callId);
	};

	const handleAnswerCall = () =>
	{
		handleAccept();
	};

	return (
		<Box alignItems='center' display='flex' p={1}>
			{callData?.audioCall === PRESENCE_ENUMS.incoming && callDetails?.initiator !== userData?.userId

				? (
					<Stack
						p={1}
						paddingTop={0}
						direction='row'
						spacing={2}
						width='100%'
						justifyContent='space-around'
					>
						<IconButton
							sx={{
								backgroundColor : '#007519',
								color           : '#fff',
								'&:hover'       : { backgroundColor: '#007519' },
								'&:active'      : { backgroundColor: '#007519' }
							}}
							onTouchStart={handleAnswerCall} onClick={handleAnswerCall}
						>
							<MdCall fontSize={22} />
						</IconButton>

						<IconButton
							sx={{
								backgroundColor : '#FF6767',
								color           : '#fff',
								'&:hover'       : { backgroundColor: '#FF6767' },
								'&:active'      : { backgroundColor: '#FF6767' }
							}}
							onTouchStart={handleCallCancel} onClick={handleCallCancel}
						>
							<MdCallEnd fontSize={22} onClick={handleCallCancel}/>
						</IconButton>
					</Stack>
				)
				: (
					<Stack
						p={1}
						direction='row'
						spacing={1}
						width='100%'
						justifyContent='center'
					>
						{/* <IconButton onClick={handleSwitchVd}>
							<MdVideocam fontSize={22} color='#575757' />
						</IconButton> */}
						{onGoingCall &&
							<IconButton onTouchStart={() => handleAudioOff(!callData?.audioInProgress)} onClick={() => handleAudioOff(!callData?.audioInProgress)}>
								{!callData?.audioInProgress
									? <IoMdMicOff fontSize={22} color='#575757' />
									: <IoMdMic fontSize={22} color='#575757' />}
							</IconButton >
						}
						<IconButton onTouchStart={() => (callData?.audioCall === PRESENCE_ENUMS.onGoing ? handleEndCall() : handleCallCancel())} onClick={() => (callData?.audioCall === PRESENCE_ENUMS.onGoing ? handleEndCall() : handleCallCancel())}>
							<MdCallEnd fontSize={22} color='#FF6767' />
						</IconButton>
						{/* <IconButton onClick={handleMenu}>
							<MdMoreVert fontSize={22} color='#6B7280' />
						</IconButton> */}
					</Stack>
				)}
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical   : 'top',
					horizontal : 'left'
				}}
			>
				<Stack direction='column' spacing={1} p={1}>
					{menuValues.map((item, index) => (
						<Typography key={index}
							onClick={() =>
							{
								if (index === 2)
								{
									setAnchorEl(null);
								}
							}}
							sx={{ cursor: 'pointer' }}
						>
							{item}
						</Typography>
					))}
				</Stack>

			</Popover>
		</Box>
	);
};

export default AudioCallsFooter;
